import React from 'react';
import { List, ChevronUp, ChevronDown, Trash2 } from 'lucide-react';
import { ConfigItem } from '../types';

interface ItemListProps {
    items: ConfigItem[];
    onRemoveItem: (id: number) => void;
    onUpdateItem: (id: number, field: keyof ConfigItem, value: string) => void;
    onMoveItemUp: (index: number) => void;
    onMoveItemDown: (index: number) => void;
}

const ItemList: React.FC<ItemListProps> = ({ 
    items, 
    onRemoveItem, 
    onUpdateItem, 
    onMoveItemUp, 
    onMoveItemDown 
}) => {
    if (items.length === 0) return null;

    return (
        <div className="bg-white rounded-xl shadow-sm border">
            <div className="p-4 border-b bg-gray-50 rounded-t-xl">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <List size={20} className="text-purple-600"/>
                        <h2 className="font-medium text-gray-800">لیست آیتم‌ها</h2>
                        <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs">
                            {items.length} آیتم
                        </span>
                    </div>
                </div>
            </div>

            <div className="p-4 space-y-3">
                {items.map((item, index) => (
                    <div key={item.id}
                         className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors">
                        <div className="flex items-center gap-3">
                            {/* Drag Handle */}
                            <div className="flex flex-col gap-1">
                                <button
                                    onClick={() => onMoveItemUp(index)}
                                    disabled={index === 0}
                                    className={`p-1 rounded transition-colors ${
                                        index === 0
                                            ? 'text-gray-300 cursor-not-allowed'
                                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
                                    }`}
                                    title="انتقال به بالا"
                                >
                                    <ChevronUp size={16}/>
                                </button>
                                <button
                                    onClick={() => onMoveItemDown(index)}
                                    disabled={index === items.length - 1}
                                    className={`p-1 rounded transition-colors ${
                                        index === items.length - 1
                                            ? 'text-gray-300 cursor-not-allowed'
                                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
                                    }`}
                                    title="انتقال به پایین"
                                >
                                    <ChevronDown size={16}/>
                                </button>
                            </div>

                            {/* Item Fields */}
                            <div className="flex-1 grid md:grid-cols-3 gap-3">
                                <input
                                    type="text"
                                    value={item.title}
                                    onChange={(e) => onUpdateItem(item.id, 'title', e.target.value)}
                                    className="p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder="عنوان آیتم"
                                />
                                <input
                                    type="url"
                                    dir={'ltr'}
                                    value={item.image}
                                    onChange={(e) => onUpdateItem(item.id, 'image', e.target.value)}
                                    className="p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder="آدرس تصویر"
                                />
                                <input
                                    type="url"
                                    dir={'ltr'}
                                    value={item.url}
                                    onChange={(e) => onUpdateItem(item.id, 'url', e.target.value)}
                                    className="p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder="آدرس لینک"
                                />
                            </div>

                            {/* Delete Button */}
                            <button
                                onClick={() => onRemoveItem(item.id)}
                                className="bg-red-500 hover:bg-red-600 text-white p-2 rounded transition-colors flex-shrink-0"
                                title="حذف آیتم"
                            >
                                <Trash2 size={16}/>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ItemList; 